"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHONE_NUM_DIGITS_TO_HASH = 5;
function hashEmail(username, provider) {
    var hashedUsername = ''; // TODO: should hash username (md5, sha, etc)
    return hashedUsername + "@" + provider;
}
exports.hashEmail = hashEmail;
function hashPhone(visiblePart, hiddenPart) {
    if (visiblePart === void 0) { visiblePart = ''; }
    if (hiddenPart === void 0) { hiddenPart = ''; }
    var hashedHiddenPart = Array(exports.PHONE_NUM_DIGITS_TO_HASH + 1).join('*'); // TODO: should hash hidden part (md5, sha, etc)
    return "" + visiblePart + hashedHiddenPart;
}
exports.hashPhone = hashPhone;
//# sourceMappingURL=hashers.js.map